import React from 'react';
import NodeWrapper from './NodeWrapper';

import EnterprisesApp from './themes/classic/EnterprisesApp';

const UserNode = (props) => {
  const iconStyle = {
    top: '30%',
    left: '30%',
    width: 40,
    height: 40,
  }
  return (
    <NodeWrapper noEdit {...props}>
     <EnterprisesApp props={props} iconStyle={iconStyle}/>
      {/* <div className='user-node node-highlighter'>
        <Handle type="source" node="user" position="left" className="user-left-handler" />
        <Icon defaultIcon={'enterprises_app'} icon={props?.data?.icon} style={{ marginLeft: 31, marginTop: 31, fontSize: 18, width: 38, height: 38 }} />

        <Title title={props.data.label} noStrip={true} />
      </div>
      <Handle type="target" node="user" position="right" className="user-right-handler" /> */}
    </NodeWrapper>
  );
};

export default UserNode;